import { ArrowRightAlt } from '@mui/icons-material';
import { Button, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PRIMARY_GREEN, SECONDARY_GRAY, WHITE } from './constants';
import { CurrencyButtonStyleProps, UnitsButtonStyleProps } from './GridFormatter.props';


export const StyledRoot = styled('div')({
  position: 'absolute',
  top: '-2px',
  left: '-5px',
});

export const StyledFormatterButton = styled(Button)<CurrencyButtonStyleProps>(({
  theme,
  $foreignCurrency,
  $isExportMode,
}) => {
  const primaryGreen = (theme as any).palette?.green?.primary || PRIMARY_GREEN;
  const accentColor = $isExportMode ? '#000' : primaryGreen;

  return {
    padding: '0 14px 0 8px',
    minWidth: 'auto',
    fontSize: '12px',
    borderRadius: '0',
    borderBottomRightRadius: '10px',
    lineHeight: 'inherit',
    backgroundColor: WHITE,
    fontWeight: 800,
    maxHeight: '19px',
    '&:hover': {
      backgroundColor: $foreignCurrency ? accentColor : WHITE,
    },
  };
});

export const StyledCurrencyButton = styled(StyledFormatterButton)<CurrencyButtonStyleProps>(({
  theme,
  $foreignCurrency,
  $isExportMode,
}) => {
  const primaryGreen = (theme as any).palette?.green?.primary || PRIMARY_GREEN;
  const accentColor = $isExportMode ? '#000' : primaryGreen;

  return {
    backgroundColor: $foreignCurrency ? accentColor : WHITE,
    color: $foreignCurrency ? WHITE : accentColor,
    border: `1px solid ${accentColor}`,
    zIndex: 1,
  };
});

export const StyledNumberButton = styled(StyledFormatterButton)({
  color: SECONDARY_GRAY,
  border: `1px solid ${SECONDARY_GRAY}`,
  borderLeft: 'none',
  paddingLeft: '16px !important',
  left: '-8px',
});

export const StyledCurrencyIcon = styled(ArrowRightAlt)({
  padding: '0 2px',
  display: 'block',
  width: '20px !important',
  height: 'auto !important',
  fill: `${WHITE} !important`,
});

export const StyledMenuSeparator = styled(MenuItem)({
  borderBottom: '1px solid #EFEFEF',
});

export const StyledShowMoreLess = styled(MenuItem)(({ theme }) => ({
  fontSize: '0.875rem',
  color: (theme as any).palette?.grey?.[400] || '#9e9e9e',
}));

export const StyledUnitsButton = styled(Button)<UnitsButtonStyleProps>(({ $foreignCurrency }) => ({
  padding: '0 14px 0 8px',
  minWidth: 'auto',
  fontSize: '12px',
  borderRadius: '0',
  borderBottomRightRadius: '10px',
  lineHeight: 'inherit',
  backgroundColor: WHITE,
  fontWeight: 800,
  maxHeight: '19px',
  color: SECONDARY_GRAY,
  border: `1px solid ${SECONDARY_GRAY}`,
  borderLeft: 'none',
  paddingLeft: '16px !important',
  left: '-8px',
  '&:hover': {
    backgroundColor: $foreignCurrency ? PRIMARY_GREEN : WHITE,
  },
}));
